(function () {
  function initGalleries(root) {
    root.querySelectorAll(".gh-new-product-gallery .submedia-list__main").forEach(function (gallery) {
      var count = Number(gallery.dataset.galleryCount);
      if (count < 2 || gallery.galleryCleanup || typeof Swiper === "undefined") return;

      var desktop = window.matchMedia("(min-width: 750px)");
      var wrapper = gallery.querySelector(".swiper-wrapper");
      var slides = Array.from(wrapper.children);
      var originals = slides.filter(function (slide) { return slide.dataset.galleryCopy === "1"; });
      var mediaIds = originals.map(function (slide) { return slide.querySelector("[data-media-id]").dataset.mediaId; });
      var selectedIndex = Math.floor(count / 2);
      var firstMedia = document.getElementById(mediaIds[0] + "-wrapper");
      var lightbox = firstMedia && firstMedia.closest("[data-product-slideshow]");

      // The legacy lightbox moves to <body>; observing its active slide keeps
      // both views in sync without changing the shared theme slider.
      var observer = new MutationObserver(function () {
        var active = lightbox.querySelector(".slider__slide--active");
        var index = active ? mediaIds.indexOf(active.dataset.mediaId) : -1;
        if (index < 0 || index === selectedIndex) return;
        selectedIndex = index;
        if (gallery.swiper) gallery.swiper.slideToLoop(index, 0, false);
      });
      if (lightbox) observer.observe(lightbox, { subtree: true, attributes: true, attributeFilter: ["class"] });

      // Repeated sets are rendered by Liquid so every image retains the theme's
      // existing lightbox click handler. The lightbox itself contains no repeats.
      gallery.querySelectorAll('[data-gallery-copy]:not([data-gallery-copy="1"]) a').forEach(function (link) {
        link.tabIndex = -1;
      });

      function updateMode() {
        if (gallery.swiper) {
          selectedIndex = gallery.swiper.realIndex % count;
          gallery.swiper.destroy(true, true);
        }
        // Restore source order after Swiper has rearranged nodes for looping.
        slides.forEach(function (slide) { wrapper.appendChild(slide); });
        var isStatic = desktop.matches && count <= 3;
        gallery.classList.toggle("gallery-static", isStatic);
        if (isStatic) return;

        new Swiper(gallery, {
        slidesPerView: 1.3,
        spaceBetween: 20,
        grabCursor: true,
        centeredSlides: true,
        initialSlide: selectedIndex,
        loop: true,
        loopAdditionalSlides: 2,
        speed: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 350,
        breakpoints: {
          750: {
            slidesPerView: 3.3,
            spaceBetween: 32
          }
        },
        on: {
          slideChange: function (swiper) {
            selectedIndex = swiper.realIndex % count;
          },
          afterInit: function (swiper) {
            swiper.slides.forEach(function (slide) {
              var index = Number(slide.dataset.swiperSlideIndex);
              slide.setAttribute("aria-label", (index % count + 1) + " / " + count);
            });
          }
        }
        });
      }
      updateMode();
      desktop.addEventListener("change", updateMode);
      gallery.galleryCleanup = function () {
        desktop.removeEventListener("change", updateMode);
        observer.disconnect();
        if (gallery.swiper) gallery.swiper.destroy(true, true);
        delete gallery.galleryCleanup;
      };
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initGalleries(document); });
  } else {
    initGalleries(document);
  }
  document.addEventListener("shopify:section:load", function (event) { initGalleries(event.target); });
  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll(".submedia-list__main").forEach(function (gallery) {
      if (gallery.galleryCleanup) gallery.galleryCleanup();
    });
  });
})();
